import styled from 'styled-components';
import { colors } from '../../../base/styled/variables.styled';
import { typography } from "../../../base/styled/typography.style";
export const TooltipContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$isVisible', '$inverse'].includes(prop),
}) `
  box-sizing: border-box;
  background: ${props => props.$inverse ? colors.neutral000 : colors.neutral800};
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 40px;
  max-width: 304px;
  position: relative;
  z-index: 1000;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 200ms ease-out;
  pointer-events: ${props => props.$isVisible ? 'auto' : 'none'};
`;
export const TooltipHeadline = styled.h3.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  ${typography.body3Highlight}
  color: ${props => props.$inverse ? colors.neutral800 : colors.neutral000};
  margin: 0 0 4px 0;
`;
export const TooltipSupportingText = styled.p `
  ${typography.body4}
  color: ${props => props.$inverse ? colors.neutral800 : colors.neutral000};
  margin: 0;
`;
export const TooltipButtonsContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$layout', '$inverse'].includes(prop),
}) `
  display: flex;
  gap: ${props => props.$layout === 'spaced' ? '0' : '4px'};
  align-items: center;
  justify-content: ${props => props.$layout === 'spaced' ? 'space-between' : 'flex-start'};
  margin: 12px -16px -12px -16px;
  padding: 0 4px 4px 4px;

  button {
    flex: 0 1 85px;
    ${typography.body2Highlight}
    color: ${props => props.$inverse ? colors.brand500 : colors.umbuGreen300};

    span svg {
      top: 0;
    }
  }
`;
export const TooltipTrigger = styled.span `
  display: inline-block;
  cursor: help;
`;
//# sourceMappingURL=Tooltip.style.js.map